import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-end mt-8"
}
const _hoisted_2 = { class: "version-style" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div id=\"user-info-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM55,214a0,0,0,0,0-0,0V846a0,0,0,0,0,0,0H410a0,0,0,0,0,0-0V214a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-carousel-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM430,214a0,0,0,0,0-0,0V846a0,0,0,0,0,0,0H1866a0,0,0,0,0,0-0V214a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-goal-modal-hightlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM0,0a0,0,0,0,0-0,0V911a0,0,0,0,0,0,0H1920a0,0,0,0,0,0-0V0a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-resumo-tab-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM43,221a0,0,0,0,0-0,0V811a0,0,0,0,0,0,0H1878a0,0,0,0,0,0-0V221a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-resumo-tab-notas-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM0,0a0,0,0,0,0-0,0V911a0,0,0,0,0,0,0H1920a0,0,0,0,0,0-0V0a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-resumo-tab-notas-linha-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM38.5,163.625a0,0,0,0,0-0,0V230.625a0,0,0,0,0,0,0H1873.5a0,0,0,0,0,0-0V163.625a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-resumo-tab-notas-linha-item-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM51,233.015625a0,0,0,0,0-0,0V355.015625a0,0,0,0,0,0,0H1861a0,0,0,0,0,0-0V233.015625a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-disponiveis-tab-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM43,525a0,0,0,0,0-0,0V1277a0,0,0,0,0,0,0H1878a0,0,0,0,0,0-0V525a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-futuras-tab-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM43,316a0,0,0,0,0-0,0V1341a0,0,0,0,0,0,0H1878a0,0,0,0,0,0-0V316a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-futuras-tab-line-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM43.5,411.5a0,0,0,0,0-0,0V500a0,0,0,0,0,0,0H2028.421875a0,0,0,0,0,0-0V411.5a0,0,0,0,0-0-0Z\"></path></svg></div><div id=\"step-futuras-tab-line-items-highlight\"><svg class=\"shepherd-modal-is-visible shepherd-modal-overlay-container\"><path d=\"M1920,911H0V0H1920V911ZM56,513a0,0,0,0,0-0,0V635a0,0,0,0,0,0,0H2015.921875a0,0,0,0,0,0-0V513a0,0,0,0,0-0-0Z\"></path></svg></div>", 11)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  id: "hand-click",
  onclick: "preventDefault()"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "42",
    height: "40",
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { filter: "url(#filter0_d_1691_548074)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M15.0978 5.07311C14.7665 4.72279 14.2055 4.70424 13.8512 5.03188L4.33082 13.8365C3.97654 14.1642 3.95778 14.7189 4.28912 15.0692L5.66873 16.5278L16.4774 6.53172L15.0978 5.07311Z",
        fill: "url(#paint0_linear_1691_548074)"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M13.4937 28.1459C14.0811 28.7669 15.0048 28.9456 15.7846 28.5826C18.1173 27.506 22.8119 25.3196 23.4651 24.9185C23.666 24.7925 23.8485 24.6536 24.0095 24.5046C24.4443 24.1025 24.7129 23.6332 24.7518 23.2211L24.755 23.2181C24.755 23.2181 24.755 23.2181 24.758 23.2213C24.7854 23.2438 33.1318 30.4212 33.1439 30.434C33.814 31.0084 34.6347 30.8165 35.1855 30.3071C35.8103 29.7293 36.087 28.7451 35.4 28.0251L23.2279 15.1433C23.0834 14.9904 23.0756 14.7588 23.2091 14.5935C23.2123 14.5905 23.2123 14.5905 23.2155 14.5875C23.2254 14.5725 23.2415 14.5576 23.2544 14.5456C23.2576 14.5426 23.2608 14.5397 23.264 14.5367C23.7141 14.1443 24.7149 13.2427 26.9822 13.731C27.2828 13.7935 27.5553 13.8518 27.8062 13.9064C28.59 14.0712 29.2304 13.8609 29.6523 13.4707C30.3931 12.7857 30.4604 11.5354 29.4047 10.7384C27.8685 9.57392 23.3025 7.77238 17.4448 7.54163L6.63611 17.5377L7.2703 20.3722C7.49208 21.3792 7.9848 22.3086 8.69873 23.0635L13.4937 28.1459Z",
        fill: "url(#paint1_linear_1691_548074)"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("filter", {
        id: "filter0_d_1691_548074",
        x: "-2",
        y: "0",
        width: "48",
        height: "48",
        filterUnits: "userSpaceOnUse",
        "color-interpolation-filters": "sRGB"
      }, [
        /*#__PURE__*/_createElementVNode("feFlood", {
          "flood-opacity": "0",
          result: "BackgroundImageFix"
        }),
        /*#__PURE__*/_createElementVNode("feColorMatrix", {
          in: "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }),
        /*#__PURE__*/_createElementVNode("feOffset", { dy: "4" }),
        /*#__PURE__*/_createElementVNode("feGaussianBlur", { stdDeviation: "2" }),
        /*#__PURE__*/_createElementVNode("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }),
        /*#__PURE__*/_createElementVNode("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        }),
        /*#__PURE__*/_createElementVNode("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_1691_548074"
        }),
        /*#__PURE__*/_createElementVNode("feBlend", {
          mode: "normal",
          in: "SourceGraphic",
          in2: "effect1_dropShadow_1691_548074",
          result: "shape"
        })
      ]),
      /*#__PURE__*/_createElementVNode("linearGradient", {
        id: "paint0_linear_1691_548074",
        x1: "56.3572",
        y1: "53.7075",
        x2: "11.1642",
        y2: "7.48946",
        gradientUnits: "userSpaceOnUse"
      }, [
        /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#003C66" }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "1",
          "stop-color": "#0095FF"
        })
      ]),
      /*#__PURE__*/_createElementVNode("linearGradient", {
        id: "paint1_linear_1691_548074",
        x1: "56.3572",
        y1: "53.7075",
        x2: "11.1642",
        y2: "7.48946",
        gradientUnits: "userSpaceOnUse"
      }, [
        /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#003C66" }),
        /*#__PURE__*/_createElementVNode("stop", {
          offset: "1",
          "stop-color": "#0095FF"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "pulsating-circle" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "tutorial-overlay" }, null, -1)

import { onMounted, ref } from 'vue';
import { OrganismsBar, OrganismsSubBar } from '@/components/organisms';
import { AtomPreloader } from '@/components/atoms';
import { Authentication } from '@/store';
import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let locale: string = messages[getLanguage()]['message'];

const version = ref('');

function toBlur()
{
	document.body.style.cssText="-webkit-filter: blur(10px);-moz-filter: blur(10px);-ms-filter: blur(10px);-o-filter: blur(10px);filter: blur(10px);"
}

function toClear()
{
	document.body.style.cssText="-webkit-filter: blur(0px);-moz-filter: blur(0px);-ms-filter: blur(0px);-o-filter: blur(0px);filter: blur(0px);"
}

onMounted(() => {  
  document.title = locale['common']['web_title'];
  document.body.oncopy = function(){ return false }; 
	document.body.oncontextmenu = function(){ return false }; 
	document.body.onselectstart = document.body.ondrag = function() { return false; }
 	
  Authentication.actions.ActionCheckToken();

  fetch('version')
  .then(response => response.text())
  .then(csvString => {
    version.value = csvString;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            (_unref(Authentication).getters.getStatusLoggedIn.value)
              ? (_openBlock(), _createBlock(_unref(OrganismsBar), { key: 0 }))
              : _createCommentVNode("", true),
            (_unref(Authentication).getters.getStatusLoggedIn.value)
              ? (_openBlock(), _createBlock(_unref(OrganismsSubBar), { key: 1 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([[_unref(Authentication).getters.getStatusLoggedIn.value ? 'area-content' : ''], "h-100"])
            }, [
              _createVNode(_component_router_view),
              (_unref(Authentication).getters.getStatusLoggedIn.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('message.common.version')) + " " + _toDisplayString(version.value) + " © " + _toDisplayString(_ctx.$t('message.common.rights_reserved')), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(AtomPreloader)),
    _hoisted_3,
    _hoisted_14,
    _hoisted_15
  ], 64))
}
}

})